import React from "react";
import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Cell,
} from "recharts";

export interface StudentDistributionProps {
  data: Array<{
    category: string;
    count: number;
    color: string;
    percentage: string;
  }>;
  isFullScreen?: boolean;
}

export const StudentDistributionChart: React.FC<StudentDistributionProps> = ({
  data,
  isFullScreen = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          {t("analytics.charts.distribution")}
        </h3>
      </div>
      <div className={`${!isFullScreen ? "h-80" : "h-[55vh]"}`}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              className="stroke-gray-200 dark:stroke-gray-700"
              horizontal={false}
            />
            <XAxis
              type="number"
              className="text-gray-600 dark:text-gray-300"
              tickFormatter={(value) => `${value}`}
            />
            <YAxis
              dataKey="category"
              type="category"
              width={150}
              className="text-gray-600 dark:text-gray-300"
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                color: "#111827",
                padding: "12px",
              }}
              formatter={(value: number, name, props) => {
                if (!props?.payload?.[0]) return ["", ""];
                const payload = props.payload[0];
                return [
                  `${value} ${t("analytics.labels.students")} (${payload.percentage}%)`,
                  payload.category,
                ];
              }}
            />
            <Bar dataKey="count" radius={[0, 4, 4, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
